import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ValueSection from "./components/ValueSection";
import ArticlePreview from "./components/ArticlePreview";
import CTASection from "./components/CTASection";

const SITE_URL = "https://pandabuy.lifestyle";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "PandabuySpreadsheet",
  "url": SITE_URL,
  "description": "Ultimate fashion and lifestyle shopping spreadsheet system with curated product lists across 14 categories.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "PandabuySpreadsheet",
  "url": SITE_URL,
  "description": "Curated fashion spreadsheet hub helping users find, compare, and organize the best fashion picks across 14 categories."
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <link rel="canonical" href={SITE_URL} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ValueSection />
        <ArticlePreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}